/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const $path = location.pathname;
	const thisSearch = location.search;
	let thisParam = [];
	if(thisSearch) { thisParam = thisSearch.replace(/\?/, '').split('&'); }
	let thisLat, thisLon, thisMax, thisZoom, thisCity, thisKeyword;
	let currentPin = '/images/stores/current.svg';
	let pointFlag = false;
	const $lang = $path.split('/')[1]
	let langPath = $lang === 'en' ? 'en/' : '';
	const getAreaParam = () => {
		return thisParam.find(param => param.startsWith('p_area=')) 
			? thisParam.find(param => param.startsWith('p_area=')).split('=')[1] 
			: '';
	};

	// JSON取得 ===============================================
	// 店舗一覧
	const getJSONshopLists = (_lang, _brand, _param) => {
		return `/ajax/${_lang}tenpo/tenpo_list${_brand}.json${_param}`;
	}
	// 都道府県一覧
	const getJSONshopListsArea = () => {
		return `/ajax/tenpo/area_list.json`;
	}
	// 英語　エリア一覧
	const getJSONshopListsAreaEn = () => {
		return `/ajax/en/tenpo/area_list.json`;
	}

	// ============ ↓↓ FUNCTIONS ↓↓ =＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	const maxToZoom = (_max) => {
		let zoom;
		if(FUNCTIONS.va.window.width > 768) {
			switch(_max) {
			case'1000000': zoom = 5; break;
			case'500000': zoom = 6; break;
			case'200000': zoom = 7; break;
			case'150000': zoom = 8; break;
			case'100000': zoom = 9; break;
			case'50000': zoom = 10; break;
			case'20000': zoom = 11; break;
			case'10000': zoom = 12; break;
			case'5000': zoom = 13; break;
			case'2000': zoom = 14; break;
			case'1000': zoom = 15; break;
			case'500': zoom = 16; break;
			case'200': zoom = 17; break;
			case'100': zoom = 18; break;
			case'50': zoom = 19; break;
			case'20': zoom = 20; break;
			case'10': zoom = 21; break;
			default: zoom = 12; break;
			}
		} else {
			switch(_max) {
			case'1000000': zoom = 4; break;
			case'500000': zoom = 5; break;
			case'200000': zoom = 6; break;
			case'150000': zoom = 7; break;
			case'100000': zoom = 8; break;
			case'50000': zoom = 9; break;
			case'20000': zoom = 10; break;
			case'10000': zoom = 11; break;
			case'5000': zoom = 12; break;
			case'2000': zoom = 13; break;
			case'1000': zoom = 14; break;
			case'500': zoom = 15; break;
			case'200': zoom = 16; break;
			case'100': zoom = 17; break;
			case'50': zoom = 18; break;
			case'20': zoom = 19; break;
			case'10': zoom = 20; break;
			default: zoom = 12; break;
			}
		}
		return zoom;
	};

	// 検索パラメータを変数にセット
	const setParamForMap = () => {
		for(let i=0; i<thisParam.length; i++) {
			switch(thisParam[i].split('=')[0]) {
			case'p_lat': thisLat = Number(thisParam[i].split('=')[1]); break;
			case'p_lon': thisLon = Number(thisParam[i].split('=')[1]); break;
			case'p_max': thisMax = Number(thisParam[i].split('=')[1]); thisZoom = maxToZoom(thisParam[i].split('=')[1]); break;
			default:
			}
		}
		if(!thisZoom) { thisZoom = 12; }
	};

	// 検索パラメータ引き継ぎ
	const setParam = () => {
		// 緯度経度、範囲意外の絞り込みパラメータとキーワードのみ引き継ぎする
		let newParam = '';
		for(let i=0; i<thisParam.length; i++) {
			if(thisParam[i].split('=')[0] !== 'p_lat' &&
				thisParam[i].split('=')[0] !== 'p_lon' &&
				thisParam[i].split('=')[0] !== 'p_max') {
				newParam += `&${thisParam[i].split('=')[0]}=${thisParam[i].split('=')[1]}`;
			}
		}
		return newParam;
	};

	// 検索結果一覧から店舗情報を取得しマーカーを立てる
	const setMarker = async (_map) => {
		// 県コード
		const brand = $path.includes('/orientstar/')? '_os' : $path.includes('/orient/') ? '_or' : '';
		let capitalCode = '';
		let jsonUrl = getJSONshopLists(langPath, brand, thisSearch);

		// ポップアップのテンプレート
		let componentsPopup = await fetch('/cnt_common/js/html/stores-map-popup.html').then(res => res.text());

		
		// 位置情報データを確実に取得してからフェッチを実行する
		const setupFetchWithPosition = (_json, _map) => {
			// 位置情報データが確認できてからフェッチを実行する
			fetch(_json)
				.then(response => response.json())
				.then(data => {
					const marker = [];
					let $result = data.rt_bn_tenpo_list;
					let latLngBounds = new google.maps.LatLngBounds();
					let validMarkerCount = 0; // 有効なマーカー数をカウント

					// 同じ緯度経度の出現回数をカウント
					const locationCount = {};

					for(let i = 0; i < $result.length; i++) {
						const latStr = $result[i].cf_t_latitude;
						const lngStr = $result[i].cf_t_longitude;
						
						// 緯度経度が存在しない、または空の場合はスキップ
						if(!latStr || !lngStr || latStr === '' || lngStr === '') {
							console.warn(`Empty coordinates for store ${i}:`, $result[i].cf_t_name, 'lat:', latStr, 'lng:', lngStr);
							continue;
						}
						
						const lat = Number(latStr);
						const lng = Number(lngStr);
						
						// 緯度経度の妥当性チェック（緯度: -90～90、経度: -180～180）
						if(isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
							console.warn(`Invalid coordinates for store ${i}:`, $result[i].cf_t_name, 'lat:', lat, 'lng:', lng);
							continue; // 無効なデータはスキップ
						}
						
						validMarkerCount++; // 有効なマーカーをカウント
						
						const key = `${lat},${lng}`;
						
						// 同じ位置のマーカー数をカウント
						if (!locationCount[key]) {
							locationCount[key] = 0;
						}
						
						// 同じ位置のマーカーには微小なオフセットを追加
						const offset = locationCount[key] * 0.000005; // 約0.5m程度のオフセット
						const angle = locationCount[key] * (Math.PI * 2 / 8); // 8方向に分散
						const offsetLat = lat + (Math.cos(angle) * offset);
						const offsetLng = lng + (Math.sin(angle) * offset);
						
						locationCount[key]++;
						
						let markerLatLng = new google.maps.LatLng({
							lat: offsetLat,
							lng: offsetLng
						});
						latLngBounds.extend(markerLatLng);
						let markerIconPath = '/images/stores/pin.svg';
						let markerIconZindex = 1;
						marker[i] = new google.maps.Marker({
							position: markerLatLng,
							map: _map,
							icon: new google.maps.MarkerImage(markerIconPath),
							zIndex: markerIconZindex
						});

						// 店舗情報のHTML
						marker[i].addListener('click', () => {
							const _url = $result[i].cf_t_url;
							const _storeName = $result[i].cf_t_name;
							const _address = $result[i].cf_t_address;
							const _tel = $result[i].cf_t_tel;
							const _lat = $result[i].cf_t_latitude;
							const _lon = $result[i].cf_t_longitude;	
							const _routeLink = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(_lat)},${encodeURIComponent(_lon)}`;
							let _labels = '';
							if($result[i].cf_t_tags.length) {
								_labels += '<ul class="__labelWrap">';
								$result[i].cf_t_tags.forEach(label => {
									if($lang === 'en') {
										let iconEn = label.cf_tt_icon_en;
										if(iconEn !== null && iconEn !== '') {
											_labels += `<li>
													<span class="__label">
														<img src="/tenpo_file/file/${iconEn}" alt="${label.cf_tt_group_name_en}" loading="lazy" width="129" height="12" class="" title="">
													</span>
												</li>`;
										}
									} else {
										let iconJp = label.cf_tt_icon_jp;
										if(iconJp !== null && iconJp !== '') {
											_labels += `<li>
													<span class="__label">
														<img src="/tenpo_file/file/${iconJp}" alt="${label.cf_tt_group_name_jp}" loading="lazy" width="129" height="12" class="" title="">
													</span>
												</li>`;
										}
									}
									
								});
								_labels += '</ul>';
							}
							const chipHTML = componentsPopup
								.replace('{!storeLink!}', _url)
								.replace('{!storeName!}', _storeName)
								.replace('{!address!}', _address)
								.replace('{!tel!}', _tel)
								.replace('{!routeLink!}', _routeLink)
								.replace('{!labels!}', _labels);

							// マーカークリック時に表示する情報ウィンドウを作成
							const infoWindow = new google.maps.InfoWindow({
								content: chipHTML,
								maxWidth: 300
							});

							// 情報ウィンドウを管理するグローバル配列を作成
							if (!window.openInfoWindows) window.openInfoWindows = [];

							// 新しいウィンドウを開く前に、既存のすべての情報ウィンドウを閉じる
							window.openInfoWindows.forEach(iw => iw.close());
							window.openInfoWindows = [];

							// この情報ウィンドウを追跡配列に追加する
							window.openInfoWindows.push(infoWindow);

							// 情報ウィンドウが開かれた後に閉じるボタンのリスナーをセットアップする
							google.maps.event.addListener(infoWindow, 'domready', () => {
								const closeButtons = document.querySelectorAll('.gm-style-iw-a .stores-top-map_popup .__close');
								closeButtons.forEach(button => {
									button.addEventListener('click', () => {
										infoWindow.close();
										const index = window.openInfoWindows.indexOf(infoWindow);
										if (index > -1) window.openInfoWindows.splice(index, 1);
									});
								});
							});
							
							// マーカーの上に情報ウィンドウを表示する
							infoWindow.open(_map, marker[i]);
						});
					};

					// 有効なマーカーがない場合は東京エリアを表示
					if(validMarkerCount === 0) {
						console.warn('No valid markers found - showing Tokyo area');
						const tokyoCenter = { lat: 35.6812, lng: 139.7671 }; // 東京駅周辺
						_map.setCenter(tokyoCenter);
						_map.setZoom(12);
						return;
					}

					// 緯度経度の指定がなく、複数件の場合は全てのマーカーが表示されるようにズームレベルを調整する
					if(!thisLat && !thisLon && validMarkerCount > 1) {
						// latLngBoundsが空でないことを確認してからfitBoundsを実行
						if(!latLngBounds.isEmpty()) {
							if(FUNCTIONS.va.window.width > 768) {
								_map.fitBounds(latLngBounds);
							} else {
								_map.fitBounds(latLngBounds, 50);
							}
						} else {
							console.warn('latLngBounds is empty - no valid markers to fit');
						}
					}
				})
				.catch(error => console.error('Error fetching shop data:', error));
		};
		
		if(thisSearch.includes('p_lat=') && thisSearch.includes('p_lon=') && thisSearch.includes('p_max=')) {
			// 現在地検索
			setupFetchWithPosition(jsonUrl, _map);
		} else {
			// 初期表示（首都判定が「1」のエリアを表示）
			const allParamsEmpty = thisParam.every(param => {
				const [key, value] = param.split('=');
				// .stores-top-column-left-inner内のフォーム要素のname属性を取得
				const formInputs = document.querySelectorAll('.stores-top-column-left-inner input[name], .stores-top-column-left-inner select[name], .stores-top-column-left-inner input[type="checkbox"][name]');
				const formParamNames = Array.from(formInputs).map(input => input.getAttribute('name'));
				
				// 現在のパラメータがフォーム要素のnameに含まれていない、または値が空
				return !formParamNames.includes(key) || !value || value.trim() === '';
			});
			
			if($lang === 'ja') {
				// 日
				// p_areaが無い、または値が空の場合
				let newSearch = thisSearch;
				console.log('初期表示処理');
				if (getAreaParam() === '') {
					const areaData = await fetch(getJSONshopListsArea()).then(res => res.json());
					const capitalArea = areaData.rt_bn_tenpo_area_list;
					for(let i = 0; i < capitalArea.length; i++) {
						if(capitalArea[i].cf_ta_capital === 1) {
							capitalCode = capitalArea[i]._key;
							break;
						}
					}

					if (allParamsEmpty) {
						if (thisSearch.includes('p_area=')) {
							// p_area=が含まれている場合、値をcapitalCodeに置き換える
							newSearch = thisSearch.replace(/p_area=([^&]*)/, `p_area=${capitalCode}`);
						} else {
							// p_area=が含まれていない場合、末尾に追加（?がなければ?を、あれば&を使う）
							if (newSearch === '') {
								newSearch = `?p_area=${capitalCode}`;
							} else if (newSearch.startsWith('?')) {
								newSearch += `&p_area=${capitalCode}`;
							} else {
								newSearch = `?${newSearch}&p_area=${capitalCode}`;
							}
						}
					}
					jsonUrl = getJSONshopLists(langPath, brand, newSearch);
				}
				setupFetchWithPosition(jsonUrl, _map);
			} else {
				// 英
				if (allParamsEmpty) {
					const areaData = await fetch(getJSONshopListsArea()).then(res => res.json());
					const capitalArea = areaData.rt_bn_tenpo_area_list;
					for(let i = 0; i < capitalArea.length; i++) {
						if(capitalArea[i].cf_ta_capital === 1) {
							capitalCode = capitalArea[i]._key;
							break;
						}
					}
					newSearch = thisSearch;
					if (newSearch.includes('p_country=')) {
						newSearch = newSearch.replace(/p_country=([^&]*)/, `p_country=ja`);
					} else {
						if (newSearch === '') {
							newSearch = `?p_country=ja`;
						} else if (newSearch.startsWith('?')) {
							newSearch += `&p_country=ja`;
						} else {
							newSearch = `?${newSearch}&p_country=ja`;
						}
					}
					if (thisSearch.includes('p_area=')) {
						// p_area=が含まれている場合、値をcapitalCodeに置き換える
						newSearch = thisSearch.replace(/p_area=([^&]*)/, `p_area=${capitalCode}`);
					} else {
						// p_area=が含まれていない場合、末尾に追加(?がなければ?を、あれば&を使う)
						if (newSearch === '') {
							newSearch = `?p_area=${capitalCode}`;
						} else if (newSearch.startsWith('?')) {
							newSearch += `&p_area=${capitalCode}`;
						} else {
							newSearch = `?${newSearch}&p_area=${capitalCode}`;
						}
					}
					jsonUrl = getJSONshopLists(langPath, brand, newSearch);						setupFetchWithPosition(jsonUrl, _map);
				} else {
					setupFetchWithPosition(jsonUrl, _map);
				}
		
			}
		}
	
	};

	// マップ作成
	const setMap = () => {
		const googleCliKey = 'AIzaSyAZSi-6ZaEy7pR1BbBwKWc3XSDyPtPWu44';
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = `//maps.googleapis.com/maps/api/js?key=${googleCliKey}&v=quarterly&libraries=geometry`;
		script.id = 'googleApiScript';
		script.async = true;

		// 県コード
		const brand = $path.includes('/orientstar/') ? '_os' : $path.includes('/orient/') ? '_or' : '';
		let firstItem = '';
		let capitalCode = '';
		let jsonUrl = getJSONshopLists(langPath, brand, thisSearch);
		
		// 現在地検索の場合、フラグをtrueにする
		if(thisSearch.includes('p_lat=') && thisSearch.includes('p_lon=') && thisSearch.includes('p_max=')) {
			pointFlag = true;
		}

		// 現在地検索で現在地情報が取得できない場合
		if(thisLat === undefined && thisLon === undefined && pointFlag === true) {
			// 位置情報の取得が拒否された場合はajax/tenpo/area_list.jsonから該当国の首都判定が「1」のエリアを表示する。
		}
		
		
		const createMap = (_json) => {
			// 位置情報データを確実に取得してからフェッチを実行する
			fetch(jsonUrl)
				.then(response => response.json())
				.then(data => {
					firstItem = data.rt_bn_tenpo_list[0];

					// 0件の場合
					if(!data.rt_bn_tenpo_list.length) {
						const msg0 = document.querySelectorAll('.js-0-msg');
						const msgResult = document.querySelector('.js-result-msg');
						const mapBlock = document.querySelectorAll('.js-map');
						const resultList = document.querySelector('.js-result-list');
						const paginateList = document.querySelectorAll('.js-result-paginate');

						if(paginateList.length) {
							paginateList.forEach(paginate => {
								paginate.classList.add('di_none');
							});
						}

						if(msg0 && msgResult) {
							mapBlock.forEach(map => {
								map.classList.add('di_none');
							});
							msg0.forEach(msg => {
								msg.classList.remove('di_none');
							});
							msgResult.classList.add('di_none');
							resultList.classList.add('di_none');
						}
					}
				})
				.then(() => {
					script.onload = () => {
						const canvas = document.querySelectorAll('.js-map-canvas');


						const styles = [
							{
								stylers: [{ saturation: -50 }]
							},
							{
								'featureType': 'landscape',
								'elementType': 'geometry.fill',
								'stylers': [{ 'color': '#efefe4' }]
							},
							{
								'featureType': 'water',
								'stylers': [{ 'color': '#bbc1d7' }]
							}
						];

						let mapLatLng;
						if(thisLat !== undefined && thisLon !== undefined) {
							// 近傍検索
							mapLatLng = new google.maps.LatLng({ lat: thisLat, lng: thisLon });
						} else {
							// 県別
							mapLatLng = new google.maps.LatLng({
								lat: Number(firstItem.cf_t_latitude),
								lng: Number(firstItem.cf_t_longitude)
							});
						}
						
						canvas.forEach(canvasItem => {
							const map = new google.maps.Map(canvasItem, {
								center: mapLatLng,
								zoom: thisZoom,
								styles,
								mapTypeControl: false,
								fullscreenControl: false,
								streetViewControl: false
							});

							setMarker(map);

							// 位置情報ONのとき、現在位置がMAP内ならピンを表示
							const getCurrentPos = (pos) => {
								const currentMarkerLatLng = new google.maps.LatLng({
									lat: pos.coords.latitude,
									lng: pos.coords.longitude
								});
								const currentMarker = new google.maps.Marker({
									position: currentMarkerLatLng,
									map: map,
									icon: new google.maps.MarkerImage(
										currentPin,
										new google.maps.Size(74, 74),
										new google.maps.Point(0, 0),
										new google.maps.Point(9, 9)
									)
								});
							};
							navigator.geolocation.getCurrentPosition(getCurrentPos);

							// 地図ドラッグ時・スームインアウト時に再検索
							map.addListener('dragend', () => {
								let newLatLng = map.getCenter();
								// 検索範囲半径(30000m)の3/4の距離が動かされたらリロード

								if(google.maps.geometry.spherical.computeDistanceBetween(mapLatLng, newLatLng) > ((thisMax / 4) * 3)) {
									location.href = location.pathname+`?p_lat=${newLatLng.lat()}&p_lon=${newLatLng.lng()}&p_max=30000${setParam()}`;
									// location.href = location.pathname+`?p_lat=${newLatLng.lat()}&p_lon=${newLatLng.lng()}&p_max=30000`;
								}
							});
						});


					};
					document.body.appendChild(script);
				})
				.catch(error => console.error('Error fetching shop data:', error));
		};
		
		// createMap関数を定義した後に呼び出し
		if(thisSearch.includes('p_lat=') && thisSearch.includes('p_lon=') && thisSearch.includes('p_max=')) {
			// 現在地検索
			createMap(jsonUrl);	
			console.log('現在地検索');
		} else {
			const allParamsEmpty = thisParam.every(param => {
				const [key, value] = param.split('=');
				// .stores-top-column-left-inner内のフォーム要素のname属性を取得
				const formInputs = document.querySelectorAll('.stores-top-column-left-inner input[name], .stores-top-column-left-inner select[name], .stores-top-column-left-inner input[type="checkbox"][name]');
				const formParamNames = Array.from(formInputs).map(input => input.getAttribute('name'));
				
				// 現在のパラメータがフォーム要素のnameに含まれていない、または値が空
				return !formParamNames.includes(key) || !value || value.trim() === '';
			});

			// 初期表示（首都判定が「1」のエリアを表示）
			if($lang === 'ja') {
				if (getAreaParam() === '') {
					// p_areaが無い、または値が空の場合
					fetch(getJSONshopListsArea())
						.then(response => response.json())
						.then(data => {
							const capitalArea = data.rt_bn_tenpo_area_list;
							for(let i = 0; i < capitalArea.length; i++) {
								if(capitalArea[i].cf_ta_capital === 1) {
									capitalCode = capitalArea[i]._key;
									break;
								}
							}
						}).then(() => {
							let newSearch = thisSearch;

							if (allParamsEmpty) {
								if (thisSearch.includes('p_area=')) {
									// p_area=が含まれている場合、値をcapitalCodeに置き換える
									newSearch = thisSearch.replace(/p_area=([^&]*)/, `p_area=${capitalCode}`);
								} else {
									// p_area=が含まれていない場合、末尾に追加(?がなければ?を、あれば&を使う)
									if (newSearch === '') {
										newSearch = `?p_area=${capitalCode}`;
									} else if (newSearch.startsWith('?')) {
										newSearch += `&p_area=${capitalCode}`;
									} else {
										newSearch = `?${newSearch}&p_area=${capitalCode}`;
									}
								}
							}
							jsonUrl = getJSONshopLists(langPath, brand, newSearch);
							createMap(jsonUrl);	
						})
				} else {
					createMap(jsonUrl);
				}
			} else {

				if (allParamsEmpty) {
					fetch(getJSONshopListsArea())
						.then(response => response.json())
						.then(data => {
							const capitalArea = data.rt_bn_tenpo_area_list;
							for(let i = 0; i < capitalArea.length; i++) {
								if(capitalArea[i].cf_ta_capital === 1) {
									capitalCode = capitalArea[i]._key;
									break;
								}
							}
						}).then(() => {
							let newSearch = thisSearch;
							// p_keywordがある場合はp_areaは不要
							const allParamsEmpty = thisParam.every(param => {
								const [key, value] = param.split('=');
								return !value || value.trim() === '';
							});

							if (allParamsEmpty) {
								// p_country=countryCode を newSearch に追加
								if (newSearch.includes('p_country=')) {
									newSearch = newSearch.replace(/p_country=([^&]*)/, `p_country='ja'}`);
								} else {
									if (newSearch === '') {
										newSearch = `?p_country=ja`;
									} else if (newSearch.startsWith('?')) {
										newSearch += `&p_country=ja`;
									} else {
										newSearch = `?${newSearch}&p_country=ja`;
									}
								}
								if (thisSearch.includes('p_area=')) {
									// p_area=が含まれている場合、値をcapitalCodeに置き換える
									newSearch = thisSearch.replace(/p_area=([^&]*)/, `p_area=${capitalCode}`);
								} else {
									// p_area=が含まれていない場合、末尾に追加(?がなければ?を、あれば&を使う)
									if (newSearch === '') {
										newSearch = `?p_area=${capitalCode}`;
									} else if (newSearch.startsWith('?')) {
										newSearch += `&p_area=${capitalCode}`;
									} else {
										newSearch = `?${newSearch}&p_area=${capitalCode}`;
									}
								}
								jsonUrl = getJSONshopLists(langPath, brand, newSearch);
								createMap(jsonUrl);
							}
							jsonUrl = getJSONshopLists(langPath, brand, newSearch);
							createMap(jsonUrl);	
						})
				} else {
					createMap(jsonUrl);		
				}
				
			}
		}
	};

	// 現在地から探すボタン
	const searchLocation = () => {
		// 店舗検索TOP
		const topLocationButtons = document.querySelector('.js-location-btn');
		if (topLocationButtons) {
			topLocationButtons.addEventListener('click', function() {
				const getPosSuccess = (pos) => {
					location.href = `${$path}?p_lat=${pos.coords.latitude}&p_lon=${pos.coords.longitude}&p_max=30000`;
				};
				const getPosError = () => {
					alert('位置情報を取得できませんでした。');
					
					fetch(getJSONshopListsArea())
						.then(response => response.json())
						.then(data => {
							const capitalArea = data.rt_bn_tenpo_area_list;
							for(let i = 0; i < capitalArea.length; i++) {
								if(capitalArea[i].cf_ta_capital === 1) {
									const capitalCode = capitalArea[i]._key;
									location.href = `${$path}?p_area=${capitalCode}`;
								}
							}
						});
				};
				navigator.geolocation.getCurrentPosition(getPosSuccess, getPosError);
			});
		}
	};

	// 結果一覧の「経路検索」ボタン
	const routeLink= () => {
		const routeLinks = document.querySelectorAll('.js-route-link');
		routeLinks.forEach(link => {
			const lat = link.querySelector('.rt_cf_t_latitude').textContent;
			const lon = link.querySelector('.rt_cf_t_longitude').textContent;
			const routeUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(lat)},${encodeURIComponent(lon)}`;
			link.setAttribute('href', routeUrl);
		});
	}


	// ============ ↑↑ FUNCTIONS ↑↑ =＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	setParamForMap();
	setMap();
	searchLocation();
	routeLink();

	
})(window.FUNCTIONS);
